module.exports = __webpack_public_path__ + "static/media/yao.a7a22008.svg";